import type { MeasurementSystem } from '@fleet-bffs/api-contract';
import type { UnknownAction } from 'redux';
import type { ThunkAction } from 'redux-thunk';
import type { AppState } from '~/reducers';
import { bffWebApi } from '~/api';
import type oidcAuthApi from '~/domain/auth/api/oidc-auth-api';
import { deleteCachedCurrentUser } from '~/utils/service-worker-utils/service-worker-utils';
import { setMeasurementSystem } from './actions';

/**
 * Applies a measurement system change everywhere the current user is cached: the service worker's
 * `/users/current` response, the RTK Query current-user entries and the auth state. Leaving any of
 * them stale lets the old value resurface on the next launch or refetch.
 */
export const applyMeasurementSystem =
  (measurementSystem: MeasurementSystem): ThunkAction<void, AppState, unknown, UnknownAction> =>
  (dispatch) => {
    void deleteCachedCurrentUser();

    // oidcAuthApi is injected into bffWebApi, so its endpoints live on the same api object.
    // Importing it here (rather than only its type) creates an import cycle through the native
    // listener and the fetch wrapper.
    const api = bffWebApi as unknown as typeof oidcAuthApi;
    for (const endpoint of ['fetchCurrentUser', 'refreshCurrentUser'] as const) {
      dispatch(
        api.util.updateQueryData(endpoint, undefined, (draft) => {
          draft.measurementSystem = measurementSystem;
        }) as unknown as UnknownAction
      );
    }

    dispatch(setMeasurementSystem({ measurementSystem }));
  };
